var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadInfoBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 404,
    viewBox: "0 0 490 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1560_29427)",
    strokeWidth: 34,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.354-108.356L269.012-368.609c-14.028-14.023-36.771-14.023-50.799 0L-42.13-108.356c-14.027 14.023-14.027 36.759 0 50.782l260.343 260.253c14.028 14.023 36.771 14.023 50.799 0L529.354-57.574c14.028-14.023 14.028-36.759 0-50.782z",
    stroke: "url(#paint0_linear_1560_29427)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.884 412.644L456.541 152.391c-14.028-14.023-36.771-14.023-50.799 0L145.4 412.644c-14.028 14.023-14.028 36.759 0 50.782l260.342 260.253c14.028 14.023 36.771 14.023 50.799 0l260.343-260.253c14.027-14.023 14.027-36.759 0-50.782z",
    stroke: "url(#paint1_linear_1560_29427)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1560_29427",
    x1: 399.183,
    y1: -238.483,
    x2: 176.793,
    y2: -16.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46036F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1560_29427",
    x1: 586.712,
    y1: 282.518,
    x2: 364.322,
    y2: 504.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46036F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1560_29427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 490,
    height: 404,
    rx: 2,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadInfoBg);
export default __webpack_public_path__ + "static/media/upload_info_bg.ea8a3782b9eff4a79cfb9da58156daca.svg";
export { ForwardRef as ReactComponent };